import { useEffect, useRef } from 'react';

export function useInterval(callback, delay, func) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      setTimeout(function () {
        clearInterval(id);
        func(true);
      }, 2 * 60 * 1000);
      return () => clearInterval(id);
    }
  }, [delay]);
}
